import RankingPage from '../components/common/RankingPage2.vue';
import Dl2022 from '../views/Dl2022.vue';
import HomeDL2 from '../views/HomeDL2.vue';

let routes = [
  //Dl2022 Splash page
  {
    path: '/digitalleaders22',
    component: HomeDL2,
    meta: {
      page: 'Digital-Leaders'
    }
  },
  {
    path: '/digitalleaders2022',
    component: HomeDL2,
    meta: {
      page: 'Digital-Leaders'
    }
  },
  {
    path: '/digitalleaders22/methodology',
    component: HomeDL2,
    beforeEnter(to, from, next) {
      window.location.href = 'https://emerging.fr/assets/files/pr2022.pdf';
    }
  },
  {
    path: '/digitalleaders2022/meta-ranking',
    component: RankingPage,
    meta: {
      pageId: '6274e1887d664e65dfca7f9b',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/meta-ranking2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
      // link:
      //   'https://www.timeshighereducation.com/student/best-universities/digital-leaders-top-universities-digital-education',
      // linkText:
      //   'See the publication by the Times Higher Education (THE) on their student and academic website '
    }
  },
  {
    path: '/digitalleaders2022/computer-science',
    component: RankingPage,
    meta: {
      pageId: '6278ccc346758f0219c699ac',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/computerScience2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2022/data-science',
    component: RankingPage,
    meta: {
      pageId: '6278ccee46758f0219c699ad',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/dataScience2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2022/entrepreneur',
    component: RankingPage,
    meta: {
      pageId: '6278cc7c46758f0219c699ab',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/entrepreneur2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2022/online-degrees',
    component: RankingPage,
    meta: {
      pageId: '6278ccfc46758f0219c699ae',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/onlineDegrees2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2022/business-school',
    component: RankingPage,
    meta: {
      pageId: '6278cd0846758f0219c699af',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/business2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2022/diversity',
    component: RankingPage,
    meta: {
      pageId: '6278cd7146758f0219c699b0',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/diversity2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  }
];

export default routes;
